/* Collection polish: pill add to basket button on product cards. Hands the click to the
   theme's own quick add / quick view buttons so cart and variant logic stay unchanged. */
(function () {
  if (window.__tdcAtc) return;
  window.__tdcAtc = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-product__atc[data-atc]');
    if (!btn) return;
    var card = btn.closest('.card-product');
    if (!card) return;
    e.preventDefault();
    var mode = btn.getAttribute('data-atc');
    var target = card.querySelector(mode === 'add' ? '.button--quick-add' : '.button--quick-view');
    if (!target) { var link = card.querySelector('a[href*="/products/"]'); if (link) window.location = link.href; return; }
    if (mode !== 'add') {
      target.click();
      var panel = card.querySelector('.product-quick');
      if (panel && card.classList.contains('quick-active')) {
        var r = panel.getBoundingClientRect();
        if (r.top < 140) window.scrollBy({ top: r.top - 160, behavior: 'smooth' });
      }
      return;
    }
    var label = btn.querySelector('span');
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding';
    target.click();
    setTimeout(function () { label.textContent = 'Added'; btn.classList.add('is-added'); }, 700);
    setTimeout(function () { label.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; }, 2600);
    if (window.dataLayer) window.dataLayer.push({ event: 'collection_add_to_basket', product_title: (card.querySelector('.card-product__title span') || {}).textContent });
  });
})();

/* Festive offers list: add to basket without leaving the page */
(function () {
  if (window.__tdcFestiveAtc) return;
  window.__tdcFestiveAtc = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.festive__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.festive__add');
    var label = btn.querySelector('span') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding';
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (window.updateMicroCartDrawer) window.updateMicroCartDrawer(form);
        label.textContent = 'Added';
        btn.classList.add('is-added');
        if (window.dataLayer) window.dataLayer.push({ event: 'collection_add_to_basket', product_title: btn.getAttribute('data-title') });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        setTimeout(function () { label.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; }, 2400);
      });
  });
})();
